import { IChangelog, IRelease } from '@shared/interface/model.interface'
import { dbData } from './init.db.data'

// ********************************************************
// Table 'changelog'
// ********************************************************
export const dbSetChangelog = (providedChangelog?: IChangelog): Promise<number> => {
  if (providedChangelog) {
    return dbData.transaction('rw', dbData.changelog, async () => {
      await dbData.changelog.clear()

      return dbData.changelog.add(providedChangelog)
    })
  } else {
    return Promise.resolve(0)
  }
}

export const dbGetChangelog = (): Promise<IChangelog | undefined> => {
  return dbData.transaction('r', dbData.changelog, async () => {
    const changelog = await dbData.changelog.toArray()
    return changelog.length > 0 ? changelog[0] : undefined
  })
}
